import template from './adminCreateSection.html';
import controller from './adminCreateSection.controller';

let adminCreateSectionComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller,
  controllerAs: 'vm'
};

export default adminCreateSectionComponent;



// WEBPACK FOOTER //
// ./app/components/adminCreateSection/adminCreateSection.component.js